import React, { useEffect, useState, useRef, useCallback } from "react";
import { Form, notification } from "antd";
import _ from "lodash";
import dayjs from "dayjs";
import axios from "axios";
import $axios from "../services/axios";
import { MEAL_TYPE } from "../helpers/const";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);
export const useChooseHotelLogic = ({
    hotelSelected,
    formSearch,
    filterSearch,
}) => {
    const [openViewMap, setOpenViewMap] = useState(false);
    const formRef = useRef(null);
    const [form] = Form.useForm();
    const [step, setStep] = useState(1);
    const [expandedDes, setExpandedDes] = useState(false);
    const [roomSelected, setRoomSelected] = useState(null);
    const [rateSelected, setRateSelected] = useState(null);
    const [voucherValue, setVoucherValue] = useState(0);
    const [voucherCode, setVoucherCode] = useState("");
    const [voucherTxt, setVoucherTxt] = useState("");
    const [loadingBooking, setLoadingBooking] = useState(false);
    const [loading, setLoading] = useState(false);
    const [vouchers, setVouchers] = useState([]);
    const [openVoucher, setOpenVoucher] = useState(false);
    const [openHotelImagePreview, setOpenHotelImagePreview] = useState(false);
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const [invoice, setInvoice] = useState(false);
    const [invoiceCode, setInvoiceCode] = useState("");
    const [adtChoosed, setAdtChoosed] = useState(null);
    const [isPersonChecking, setIsPersonChecking] = useState(false);
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let sliderRef1 = useRef(null);
    let sliderRef2 = useRef(null);

    useEffect(() => {
        setNav1(sliderRef1);
        setNav2(sliderRef2);
    }, []);

    useEffect(() => {
        if (isPersonChecking) {
            form.setFieldsValue({
                first_name_adt: form.getFieldValue(`contactFirstName`),
                last_name_adt: form.getFieldValue(`contactLastName`),
            });
        }
    }, [isPersonChecking]);

    const toggleExpand = () => {
        setExpandedDes((prev) => !prev);
    };

    const applyVoucher = async (e) => {
        if (e) {
            setLoading(true);
            try {
                const res = await $axios.$get(`/voucher/getVoucher?voucherCode=${e}`);
                if (res.data.data.status === 1) {
                    setVoucherValue(res.data.data.amount);
                    setVoucherCode(e);
                    setVoucherTxt(
                        `<div class="text-[14px]">Áp dụng mã giảm giá thành công! <span class="text-green-600 font-bold text-[16px]">
      ${res.data.data.amount.toLocaleString("vi-VN")} đ</span></div>`
                    );
                } else {
                    setVoucherTxt(
                        `<div class="text-[14px] text-red-600">Mã giảm giá không hợp lệ! Vui lòng thử lại</div>`
                    );
                    setVoucherValue(0);
                    setVoucherCode("");
                }
            } catch (error) {
                setVoucherTxt(
                    `<div class="text-[14px] text-red-600">Mã giảm giá không hợp lệ! Vui lòng thử lại</div>`
                );
                setVoucherValue(0);
                setVoucherCode("");
            } finally {
                setLoading(false);
            }
        } else {
            setVoucherTxt(
                `<div class="text-[14px] text-red-600">Mã giảm giá không hợp lệ! Vui lòng thử lại</div>`
            );
            setVoucherValue(0);
            setVoucherCode("");
        }
    };

    const applyVoucherPick = (voucher) => {
        let amount = voucher.amountvoucher;
        if (voucher.discounttype === "PERCENTAGE") {
            const amountDiscount = Math.ceil(
                rateSelected.rateaftertaxtotal * (voucher.discountvalue / 100)
            );
            amount =
                amountDiscount < voucher.maxdiscountvalue
                    ? amountDiscount
                    : voucher.maxdiscountvalue;
        }
        setVoucherValue(amount);
        setVoucherCode(voucher.code);
        setVoucherTxt(
            `<div class="text-[14px]">Áp dụng mã giảm giá thành công! <span class="text-green-600 font-bold text-[16px]">
        ${amount.toLocaleString("vi-VN")} đ</span></div>`
        );
        setOpenVoucher(false);
    };

    const getVouchers = useCallback(async () => {
        if (!rateSelected) return;
        setLoading(true);
        try {
            const res = await $axios.$post("/voucher/getVoucherByOrder", {
                Quantity:
                    formSearch.getFieldValue("numAdults") +
                    formSearch.getFieldValue("numChilds"),
                Total: rateSelected.rateaftertaxtotal,
            });
            const now = dayjs();
            const validVouchers = res.data.data.filter((voucher) => {
                const start = dayjs(voucher.startdate);
                const end = dayjs(voucher.enddate);
                return now.isBetween(start, end, null, "[]");
            });
            setVouchers(validVouchers);
        } catch (error) {
            console.error("error getVouchers", error);
        } finally {
            setLoading(false);
        }
    }, [rateSelected, formSearch]);

    useEffect(() => {
        if (rateSelected) {
            getVouchers();
        }
    }, [rateSelected, getVouchers]);

    const handleBooking = async (values) => {
        setLoadingBooking(true);
        try {
            const body = {
                StayCheckIn: dayjs(formSearch.getFieldValue("departDate")).format(
                    "YYYY-MM-DD"
                ),
                StayCheckOut: dayjs(formSearch.getFieldValue("returnDate")).format(
                    "YYYY-MM-DD"
                ),
                HotelCode: hotelSelected.hotelcode,
                HotelName: hotelSelected.Name,
                HotelAddress: hotelSelected?.Address || hotelSelected?.AddressObj?.address,
                HotelStarNumber: hotelSelected?.starnumber || hotelSelected?.Rating?.starNumber,
                MealType: rateSelected?.mealtype || "",
                MealTypeName: MEAL_TYPE[rateSelected?.mealtype] || "",
                BookingToken: rateSelected?.bookingtoken,
                RateCategory: rateSelected?.ratecategory,
                RatePlanCode: rateSelected?.rateplancode,
                RoomTypeName: roomSelected?.roomtypename,
                RoomTypeCode: roomSelected?.roomtypecode,
                NumberOfUnits: formSearch.getFieldValue("numRooms"),
                Nights: hotelSelected?.nights,
                OccupancyPerRoom: 0,
                ContactInfoLastName: values?.contactLastName,
                ContactInfoFirstName: values?.contactFirstName,
                ContactInfoEmail: values?.contactEmail,
                ContactInfoPhone: values?.contactPhone,
                VatMst: values?.VatMst || "",
                VatFullName: values?.VatFullName || "",
                VatEmail: values?.contactEmail || "",
                VoucherCode: voucherCode,
                TotalAfterTax: rateSelected?.rateaftertaxtotal,
                TotalBeforeTax: rateSelected?.ratebeforetaxtotal,
                Amount: rateSelected?.rateaftertaxtotal - voucherValue,
                AmountOriginal: rateSelected?.rateaftertaxtotal + voucherValue,
                AmountDiscount: voucherValue,
                CancellationPolicies: rateSelected?.cancellationpolicies?.map((can) => {
                    return {
                        Penalty: can.penalty,
                        Deadline: can.deadline,
                    };
                }),
                DailyRates: rateSelected.dailyrates.map((rate) => {
                    return {
                        PeriodStartDate: rate?.periodstartdate,
                        PeriodEndDate: rate?.periodenddate,
                        RateBeforeTax: rate?.ratebeforetax,
                        RateAfterTax: rate?.rateaftertax,
                        MealCount: rate?.mealcount,
                    };
                }),
                Occupancies: _.range(
                    1,
                    formSearch.getFieldValue("numAdults") +
                    formSearch.getFieldValue("numChilds") +
                    1
                ).map((item, index) => {
                    return {
                        Type: "AD",
                        Age: 30,
                        FirstName: item === 1 ? values.first_name_adt : 'TO BE ADDED',
                        LastName: item === 1 ? values.last_name_adt : 'TO BE ADDED',
                        FullName: item === 1 ? `${values.first_name_adt + ' ' + values.last_name_adt}` : 'TO BE ADDED',
                        RoomIndex: _.range(1, formSearch.getFieldValue("numRooms") + 1).includes(item) ? item : _.sample(_.range(1, formSearch.getFieldValue("numRooms") + 1)),
                    };
                }),
                // ReturnUrl: window.location.origin + window.location.pathname,
            };
            const resPayment = await $axios.post("/hotel-tripi/payment-required", body);
            if (resPayment.data.data.rsres.ordercode) {
                sendDataToApp(resPayment.data.data.rsres.ordercode, body.Amount);
            } else {
                setLoadingBooking(false);
                notification.error({
                    status: "error",
                    message: "Thất bại",
                    description: "Đã có lỗi xảy ra! Vui lòng đặt phòng khác",
                });
            }
        } catch (error) {
            console.log(error, 'error');
            notification.warning({
                description:
                    error?.response?.data?.message || error?.response?.data?.err || "Không thể khởi tạo giao dịch thanh toán !"
            });
            setLoadingBooking(false);
        }
    };

    const sendDataToApp = async (orderCode, amount) => {
        // Send orderCode for IOS
        if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.NativeJavascriptInterface
        ) {
            // Chuyển đổi dữ liệu thành chuỗi JSON và gửi qua Swift
            window.webkit.messageHandlers.NativeJavascriptInterface.postMessage({
                orderCode: orderCode,
            });
        } else {
            console.error(
                "NativeJavascriptInterface không tồn tại hoặc không được hỗ trợ."
            );
        }
        // Send orderCode for Android
        if (window.webkit !== undefined) {
            if (window.webkit.messageHandlers.appInterface !== undefined) {
                window.webkit.messageHandlers.appInterface.postMessage(
                    JSON.stringify({
                        orderCode: orderCode,
                    })
                );
            }
        }
        if (window.appInterface !== undefined) {
            window.appInterface.postMessage(
                JSON.stringify({
                    orderCode: orderCode,
                })
            );
        }
    };

    const CheckProductAvailability = async (rate, room) => {
        setLoading(true);
        try {
            const body = {
                StayCheckIn: dayjs(formSearch.getFieldValue("departDate")).format(
                    "YYYY-MM-DD"
                ),
                StayCheckOut: dayjs(formSearch.getFieldValue("returnDate")).format(
                    "YYYY-MM-DD"
                ),
                Hotels: [String(hotelSelected.id)],
                Nationality: filterSearch.country,
                LanguageCode: "vi",
                RatePlanCode: rate.rateplancode,
                RoomTypeCode: room.roomtypecode,
                NumberOfUnits: formSearch.getFieldValue("numRooms"),
                Occupancies: {
                    Adults:
                        formSearch.getFieldValue("numAdults") +
                        formSearch.getFieldValue("numChilds"),
                    Children: 0,
                    Paxes: _.range(
                        1,
                        formSearch.getFieldValue("numAdults") +
                        formSearch.getFieldValue("numChilds") +
                        1
                    ).map((item) => {
                        return {
                            Age: 30,
                            Type: "AD",
                        };
                    }),
                },
            };
            const res = await $axios.$post(`/hotel-tripi/product-avail`, body);
            if (_.get(res, "data.data.hotels[0].status", "") === "Success") {
                const _room = _.find(
                    _.get(res, "data.data.hotels[0].rooms", []),
                    (r) => r.roomtypecode === room.roomtypecode
                );
                const _rate = _.find(
                    _.get(_room, "rates", []),
                    (r) => r.rateplancode === rate.rateplancode
                );
                setRoomSelected(_room);
                setRateSelected(_rate);
                setStep(2);
            } else {
                notification.warning({
                    description:
                        "Gói giá hiện tại không có sẵn ! Vui lòng tham khảo gói giá khác",
                });
            }
        } catch (error) {
            console.log(error, "error");
        } finally {
            setLoading(false);
        }
    };

    const debouncedCheckMst = useCallback(
        _.debounce(async (value, callback) => {
            try {
                const response = await axios.get(
                    `https://api.vietqr.io/v2/business/${value}`
                );

                if (response.data && response.data.code === "00") {
                    callback(null);
                    setInvoiceCode(response.data.data.shortName);
                } else {
                    callback(new Error(response.data.desc));
                    setInvoiceCode("");
                }
            } catch (error) {
                callback(new Error("Không thể xác minh mã số thuế"));
                setInvoiceCode("");
            }
        }, 1000),
        []
    );

    const handleValueChanges = (changeValues, allValues) => {
        if (isPersonChecking) {
            form.setFieldsValue({
                first_name_adt: form.getFieldValue(`contactFirstName`),
                last_name_adt: form.getFieldValue(`contactLastName`),
            });
        }
    };

    return {
        openViewMap,
        setOpenViewMap,
        formRef,
        form,
        step,
        setStep,
        expandedDes,
        setExpandedDes,
        roomSelected,
        setRoomSelected,
        rateSelected,
        setRateSelected,
        voucherValue,
        setVoucherValue,
        voucherCode,
        setVoucherCode,
        voucherTxt,
        setVoucherTxt,
        loadingBooking,
        setLoadingBooking,
        loading,
        setLoading,
        nav1,
        setNav1,
        nav2,
        setNav2,
        invoice,
        setInvoice,
        invoiceCode,
        setInvoiceCode,
        adtChoosed,
        setAdtChoosed,
        isPersonChecking,
        setIsPersonChecking,
        userInfo,
        sliderRef1,
        sliderRef2,
        vouchers,
        openVoucher,
        setOpenVoucher,
        openHotelImagePreview,
        setOpenHotelImagePreview,
        toggleExpand,
        applyVoucher,
        applyVoucherPick,
        handleBooking,
        CheckProductAvailability,
        debouncedCheckMst,
        handleValueChanges,
    };
};
